
<script>
import { Line } from 'vue-chartjs'
export default {
  name: 'VendaUltimos30diasChart',
  extends: Line,
  props: {
    data: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.data, this.options)
  },
}
</script>


